import { PropsWithChildren } from 'react';
import {
  unstable_BlockerFunction,
  useBlocker as useRouterBlocker,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { DianaCoreRouterContextProvider, TRouterBlockerFunction } from '@diana/core';
import { isFunction } from 'lodash';

export function CoreRouterContextConnector({ children }: PropsWithChildren<{}>) {
  return (
    <DianaCoreRouterContextProvider
      useParams={useParams}
      useLocation={useLocation}
      useNavigate={useNavigate}
      useBlocker={useBlocker}
    >
      {children}
    </DianaCoreRouterContextProvider>
  );
}

function useBlocker(blocker: boolean | TRouterBlockerFunction) {
  return useRouterBlocker(
    isFunction(blocker) ? (blocker as unknown as unstable_BlockerFunction) : blocker,
  );
}
